import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center mb-2 py-4 rounded-md" }
const _hoisted_2 = { class: "flex items-center justify-evenly w-full" }
const _hoisted_3 = { class: "text-white text-base2 font-sourcesanspro-regular" }

import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { shareOutline, shareSocialOutline } from 'ionicons/icons';
import { IonButton, IonIcon, isPlatform } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

import useTenant from '@/shared/composables/useTenant';
import useUtils from '@/shared/composables/useUtils';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'ShareAppButton',
  setup(__props) {

const { t } = useI18n();
const { getTenantConfigAndStyles } = useTenant();
const { tenantStyles } = getTenantConfigAndStyles();
const { getCurrentWindowLocationOrigin } = useUtils();

const shareApp = () => {
	if (Capacitor.isNativePlatform()) {
		// Share on native platforms
		Share.share({
			title: tenantStyles.value!.name,
			text: t('components.share_app.message'),
			url: `${getCurrentWindowLocationOrigin()}/#/share`,
		});
	} else {
		// Share on web platforms
		navigator.share({
			title: tenantStyles.value!.name,
			text: t('components.share_app.message'),
			url: `${getCurrentWindowLocationOrigin()}/#/share`,
		});
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IonButton), {
        fill: "outline",
        shape: "round",
        onClick: shareApp
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            icon: _unref(isPlatform)('android') || !_unref(Capacitor).isNativePlatform() ? _unref(shareSocialOutline) : _unref(shareOutline),
            class: "text-white mr-2"
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('components.share_app.share')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})